define('contact',['jquery', 'underscore', 'lib', 'event-manager'], function($, _, lib, eventManager) {
    'use strict';

    var ContactForm = function(element) {
        this.form = $(element);
        this.bindEvents();
    };

    $.extend(ContactForm.prototype, {
        alerts: [],

        bindEvents: function() {
            _.bindAll(this, [
                'onSuccess',
                'onError',
                'appendAlert',
                'onFormSubmit',
                'onBadRequest'
            ]);

            this.form.on('submit', this.onFormSubmit);
        },

        onFormSubmit: function(e) {
            e.preventDefault();

            var referrerEl = $('input.contact-form__referrer');
            if (referrerEl.length && document.referrer.length > 0) {
                referrerEl.val(document.referrer);
            }

            var userAgentEl = $('input.contact-form__useragent');
            if (userAgentEl.length && navigator.userAgent.length > 0) {
                userAgentEl.val(navigator.userAgent);
            }

            $.post(this.form.attr('action'), this.form.serialize(), null, 'json').done(this.onSuccess).fail(this.onBadRequest);
        },

        clearError: function() {
            $.each(this.alerts, function(i, alert) {
                $(alert).fadeOut().remove();
            });
            this.form.find('.error').removeClass('error');
        },

        clearInput: function() {
            this.form.find('input:not([type="hidden"]), textarea, select').val('');
        },

        onSuccess: function(json) {
            this.clearError();

            if (!json.status) {
                this.onError();
                return;
            }

            $(this.form.find('input, button, textarea')).prop('disabled', true);
            $('<div/>').addClass('contact-form__message contact-form__message--success').html('Meldingen er sendt!').insertAfter(this.form);
            this.form.find('button[type="submit"]').remove();

            return;
        },

        appendAlert: function(msg, fieldName) {
            var field = _.isString(fieldName) ? this.form.find(' [name="' + fieldName + '"]') : $(fieldName);
            field.addClass('error');
            // field = field.parent('label').length ? field.parent('label') : field;
            // var alert = $('<div/>').text(msg).addClass('contact-form__message contact-form__message--error').insertBefore(field);
            // this.alerts.push(alert);
        },

        onError: function() {
            this.clearError();
            var alert = $('<div/>')
                .text('Noe gikk galt. Hvis du prøvde å laste opp en fil, kan feilen være at filen var for stor. Hvis problemet fortsetter kan du sende en mail til tips@e24.no.')
                .addClass('contact-form__message contact-form__message--error')
                .insertBefore(this.form);

            this.alerts.push(alert);
        },

        onBadRequest: function(jqXHR) {
            this.clearError();

            var sumbitBtn = this.form.find('button[type="submit"]');
            sumbitBtn.removeClass('animated shake').outerWidth(sumbitBtn.outerWidth()).addClass('animated shake'); // restarts the animation

            this.alerts = [];
            if ((jqXHR.getResponseHeader('Content-Type') || '').indexOf('application/json') !== 0) {
                this.onError();
                return;
            }

            var json = JSON.parse(jqXHR.responseText);
            if (!json.messages) {
                this.onError();
                return;
            }

            var errorHandler = _.bind(function(fieldName, object) {
                for (var propertyName in object) {
                    switch (propertyName) {
                        case 'isEmpty':
                        case 'emailAddressInvalidFormat':
                        case 'emailAddressInvalidHostname':
                        case 'emailAddressInvalidMxRecord':
                            this.appendAlert(object[propertyName], fieldName);
                            break;

                        case 'fileIsImageFalseType':
                        case 'fileSizeTooBig':
                        case 'fileNotFound':
                            this.appendAlert(object[propertyName], this.form.find('.fileupload'));
                            break;

                    }
                }
            }, this);
            _.each(json.messages, function(object, fieldName) {
                switch (typeof(_.values(object)[0])) {
                    case 'string':
                        errorHandler(fieldName, object);
                        break;
                    case 'object':
                        _.each(object, function(sub, subFieldName) {
                            errorHandler(fieldName + '[' + subFieldName + ']', sub);
                        });
                        break;
                }
            }, this);
        }
    });

    eventManager.once('e24-contact-form-loaded', function() {
        lib.$('.contact-form').each(function() {
            new ContactForm($('form', this));
        });
    });
});

